(function () {
  'use strict';

  if (window.SDXProject && window.SDXProject.version === '1.1.0') return;

  var STORAGE_KEY = 'sdx_sauna_project_v1';
  var STEP_ORDER = ['finder', 'compare', 'space', 'cost', 'heater'];
  var STEP_LABELS = { finder: 'Finder brief', compare: 'Product comparison', space: 'Space fit check', cost: 'Project cost range', heater: 'Heater-room volume' };
  var DEFAULT_SUMMARIES = {
    finder: 'Capacity, placement, style, and product budget are not set.',
    compare: 'No products have been compared.',
    space: 'Usable space and sourced clearances are not set.',
    cost: 'No project-cost assumptions are saved.',
    heater: 'No heater-room volume is saved.'
  };

  function blank() { return { version: 1, updatedAt: null, steps: {}, savedProducts: [] }; }
  function cleanText(value, limit) { return String(value == null ? '' : value).replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, limit || 500); }
  function safeCopy(value, depth) {
    if (depth > 4 || value == null) return null;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value === 'string') return cleanText(value, 500);
    if (Array.isArray(value)) return value.slice(0, 24).map(function (item) { return safeCopy(item, depth + 1); });
    if (typeof value === 'object') {
      var copy = {};
      Object.keys(value).slice(0, 40).forEach(function (key) {
        if (/^[a-zA-Z0-9_-]{1,40}$/.test(key)) copy[key] = safeCopy(value[key], depth + 1);
      });
      return copy;
    }
    return null;
  }
  function read() {
    try {
      var parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!parsed || parsed.version !== 1 || !parsed.steps || typeof parsed.steps !== 'object') return blank();
      var project = blank();
      project.updatedAt = typeof parsed.updatedAt === 'string' ? parsed.updatedAt : null;
      STEP_ORDER.forEach(function (step) {
        var saved = parsed.steps[step];
        if (!saved || typeof saved !== 'object') return;
        project.steps[step] = { completedAt: typeof saved.completedAt === 'string' ? saved.completedAt : null, summary: cleanText(saved.summary || '', 800), data: safeCopy(saved.data || {}, 0) };
      });
      if (Array.isArray(parsed.savedProducts)) {
        project.savedProducts = parsed.savedProducts.slice(0, 8).map(function (product) {
          if (!product || !/^[a-z0-9-]{1,160}$/.test(product.handle || '')) return null;
          var productUrl = cleanText(product.url || '', 240);
          if (productUrl.indexOf('/products/') !== 0) productUrl = '/products/' + product.handle;
          return { handle: product.handle, title: cleanText(product.title || product.handle, 240), url: productUrl };
        }).filter(Boolean);
      }
      return project;
    } catch (_) { return blank(); }
  }
  function write(project) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(project)); return true; }
    catch (_) { return false; }
  }
  function completedCount(project) { return STEP_ORDER.filter(function (step) { return Boolean(project.steps[step]); }).length; }
  function url() {
    var availability = window.SweatDecksRouteAvailability || {};
    return availability['/pages/sauna-project'] === true ? '/pages/sauna-project' : '/pages/sauna-cost-calculator?view=sauna-project';
  }
  function notify(project) {
    render(project);
    try { document.dispatchEvent(new CustomEvent('sdx:project-updated', { detail: { completed: completedCount(project) } })); } catch (_) {}
  }
  function saveStep(step, data, summary) {
    if (STEP_ORDER.indexOf(step) === -1) return false;
    var project = read();
    var now = new Date().toISOString();
    project.updatedAt = now;
    project.steps[step] = { completedAt: now, summary: cleanText(summary, 800), data: safeCopy(data || {}, 0) };
    var saved = write(project);
    if (saved) notify(project);
    return saved;
  }
  function removeStep(step) {
    if (STEP_ORDER.indexOf(step) === -1) return;
    var project = read();
    delete project.steps[step];
    project.updatedAt = new Date().toISOString();
    write(project);
    notify(project);
  }
  function addProduct(product) {
    if (!product || !/^[a-z0-9-]{1,160}$/.test(product.handle || '')) return false;
    var project = read();
    var productUrl = cleanText(product.url || '', 240);
    if (productUrl.indexOf('/products/') !== 0) productUrl = '/products/' + product.handle;
    project.savedProducts = project.savedProducts.filter(function (item) { return item.handle !== product.handle; });
    project.savedProducts.unshift({ handle: product.handle, title: cleanText(product.title || product.handle, 240), url: productUrl });
    project.savedProducts = project.savedProducts.slice(0, 8);
    project.updatedAt = new Date().toISOString();
    var saved = write(project); if (saved) notify(project); return saved;
  }
  function removeProduct(handle) {
    if (!/^[a-z0-9-]{1,160}$/.test(handle || '')) return;
    var project = read();
    project.savedProducts = project.savedProducts.filter(function (item) { return item.handle !== handle; });
    project.updatedAt = new Date().toISOString();
    write(project); notify(project);
  }
  function clear() { try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {} notify(blank()); }
  function formatDate(value) {
    if (!value) return 'Nothing saved yet.';
    try { return 'Last updated ' + new Date(value).toLocaleString('en-US'); }
    catch (_) { return 'Project updated in this browser tab.'; }
  }
  function summaryText(project) {
    var lines = ['SweatDecks sauna project brief', 'Created from session-only planning tools', 'Updated: ' + (project.updatedAt ? new Date(project.updatedAt).toLocaleString('en-US') : 'Not started'), ''];
    STEP_ORDER.forEach(function (step, index) {
      var saved = project.steps[step];
      lines.push((index + 1) + '. ' + STEP_LABELS[step]);
      lines.push(saved ? saved.summary : DEFAULT_SUMMARIES[step]);
      lines.push('');
    });
    lines.push('Saved products');
    if (project.savedProducts.length) project.savedProducts.forEach(function (product) { lines.push('- ' + product.title + ': ' + product.url); });
    else lines.push('No products saved.');
    lines.push('');
    lines.push('Planning aid only. Confirm current exact-model documents, configuration, delivery eligibility, site conditions, utilities, clearances, permits, applicable code, and qualified-trade requirements before ordering or building.');
    return lines.join('\n');
  }
  function copyText(value) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = value; field.setAttribute('readonly', ''); field.style.position = 'fixed'; field.style.opacity = '0'; document.body.appendChild(field); field.select();
      try { document.execCommand('copy') ? resolve() : reject(new Error('copy_failed')); } catch (error) { reject(error); }
      field.remove();
    });
  }
  function exportProject(format, status) {
    var value = summaryText(read());
    if (format === 'text') {
      var blob = new Blob([value], { type: 'text/plain;charset=utf-8' }); var objectUrl = URL.createObjectURL(blob); var link = document.createElement('a');
      link.href = objectUrl; link.download = 'sweatdecks-sauna-project-brief.txt'; document.body.appendChild(link); link.click(); link.remove(); window.setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 0);
      if (status) status.textContent = 'Project brief downloaded.';
    } else if (format === 'copy') {
      copyText(value).then(function () { if (status) status.textContent = 'Project brief copied.'; }).catch(function () { if (status) status.textContent = 'Copy was blocked. Download the brief instead.'; });
    } else if (format === 'print') {
      document.body.classList.add('sdx-project-printing'); window.print(); window.setTimeout(function () { document.body.classList.remove('sdx-project-printing'); }, 0);
      if (status) status.textContent = 'Print dialog opened. Choose Save as PDF to keep a PDF copy.';
    }
  }
  function render(project) {
    project = project || read();
    var count = completedCount(project);
    var productCount = project.savedProducts.length;
    document.querySelectorAll('[data-sdx-project-link]').forEach(function (link) {
      link.href = url(); link.dataset.sdxProjectHasData = String(count > 0 || productCount > 0);
      var label = link.querySelector('[data-sdx-project-count]'); if (label) label.textContent = count + '/5';
      link.setAttribute('aria-label', 'My sauna project, ' + count + ' of 5 planning checks complete, ' + productCount + ' saved ' + (productCount === 1 ? 'product' : 'products'));
    });
    document.querySelectorAll('[data-sdx-project-product]').forEach(function (button) {
      var handle = button.getAttribute('data-sdx-product-handle');
      var isSaved = project.savedProducts.some(function (product) { return product.handle === handle; });
      button.setAttribute('aria-pressed', String(isSaved));
      button.textContent = isSaved ? 'Remove from My Sauna Project' : 'Save to My Sauna Project';
    });
    document.querySelectorAll('[data-sdx-project-workspace]').forEach(function (workspace) {
      var progress = workspace.querySelector('[data-sdx-project-progress]'); var progressLabel = workspace.querySelector('[data-sdx-project-progress-label]'); var updated = workspace.querySelector('[data-sdx-project-updated]');
      if (progress) { progress.value = count; progress.textContent = count + ' of 5'; }
      if (progressLabel) progressLabel.textContent = count + ' of 5'; if (updated) updated.textContent = formatDate(project.updatedAt);
      workspace.querySelectorAll('[data-sdx-project-step]').forEach(function (card) {
        var step = card.getAttribute('data-sdx-project-step'); var saved = project.steps[step]; card.dataset.complete = String(Boolean(saved));
        var number = card.querySelector('.sdx-project-step__number'); if (number) number.textContent = saved ? '✓' : String(STEP_ORDER.indexOf(step) + 1);
        var summary = card.querySelector('[data-sdx-project-summary]'); if (summary) summary.textContent = saved && saved.summary ? saved.summary : DEFAULT_SUMMARIES[step];
        var existing = card.querySelector('[data-sdx-project-remove]');
        if (saved && !existing) { var button = document.createElement('button'); button.type = 'button'; button.className = 'sdx-text-link'; button.setAttribute('data-sdx-project-remove', step); button.textContent = 'Remove saved check'; card.querySelector('.sdx-project-step__actions').appendChild(button); }
        else if (!saved && existing) existing.remove();
      });
      var productSection = workspace.querySelector('[data-sdx-project-products]');
      var productList = workspace.querySelector('[data-sdx-project-product-list]');
      if (productSection) productSection.hidden = productCount === 0;
      if (productList) {
        productList.replaceChildren();
        project.savedProducts.forEach(function (product) {
          var row = document.createElement('article'); row.className = 'sdx-project-product';
          var link = document.createElement('a'); link.href = product.url; link.textContent = product.title;
          var button = document.createElement('button'); button.type = 'button'; button.setAttribute('data-sdx-project-product-remove', product.handle); button.textContent = 'Remove';
          row.append(link, button); productList.appendChild(row);
        });
      }
    });
  }
  document.addEventListener('click', function (event) {
    var exportButton = event.target.closest && event.target.closest('[data-sdx-project-export]');
    if (exportButton) { var workspace = exportButton.closest('[data-sdx-project-workspace]'); return exportProject(exportButton.getAttribute('data-sdx-project-export'), workspace && workspace.querySelector('[data-sdx-project-status]')); }
    var removeButton = event.target.closest && event.target.closest('[data-sdx-project-remove]'); if (removeButton) return removeStep(removeButton.getAttribute('data-sdx-project-remove'));
    var productRemoveButton = event.target.closest && event.target.closest('[data-sdx-project-product-remove]'); if (productRemoveButton) return removeProduct(productRemoveButton.getAttribute('data-sdx-project-product-remove'));
    var productButton = event.target.closest && event.target.closest('[data-sdx-project-product]');
    if (productButton) {
      var handle = productButton.getAttribute('data-sdx-product-handle');
      var project = read(); var exists = project.savedProducts.some(function (product) { return product.handle === handle; });
      if (exists) removeProduct(handle);
      else addProduct({ handle: handle, title: productButton.getAttribute('data-sdx-product-title'), url: productButton.getAttribute('data-sdx-product-url') });
      var action = productButton.closest('.sdx-product-project-action'); var status = action && action.querySelector('[data-sdx-project-product-status]');
      if (status) status.textContent = exists ? 'Removed from your session-only project.' : 'Saved beside your planning checks in this browser tab.';
      return;
    }
    var clearButton = event.target.closest && event.target.closest('[data-sdx-project-clear]'); if (clearButton && window.confirm('Clear all saved planning checks and products from this browser tab?')) clear();
  });
  function boot() { render(read()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.SDXProject = { version: '1.1.0', read: read, saveStep: saveStep, removeStep: removeStep, addProduct: addProduct, removeProduct: removeProduct, clear: clear, completedCount: completedCount, summaryText: summaryText, url: url, render: render };
}());
